import React, { Component } from 'react';
import { string, bool, func, arrayOf, shape, number, object } from 'prop-types';
import postal from 'postal';
import styles from './styles/styles.module.scss';
import SlidingTabs from '../shared/SlidingTabs/SlidingTabs';
import { TrailActivityFeed } from '../../application/javascripts/react_components/feeds/trail_activity_feed';
import UgcSortDropdown from '../shared/UgcSortDropdown';
import { ServerCommunicationUtil } from '../../utils/server_communication_util';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { MapStatsUtil } from '../../utils/map_stats_util';

class TrailFeeds extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: props.activeTab || 'Reviews',
      activeTabIndex: 0,
      reviews: props.reviews,
      photos: props.photos && props.photosPerPage < props.photos.length ? props.photos.slice(0, props.photosPerPage) : props.photos,
      tracks: props.tracks,
      completed: props.completed,
      itemTotals: props.itemTotals,
      reviewSortOption: props.sortOption,
      photoSortOption: 'atSort',
      recordingSortOption: 'desc',
      reviewsLoaded: true,
      photosLoaded: true,
      recordingsLoaded: true,
      loadingSortedUgc: false,
      loadingMore: false
    };
  }

  componentDidMount() {
    const messagingChannelName = 'trail_show_messagingChannel';
    this.messagingChannel = postal.channel(messagingChannelName);

    if (this.props.popTrailReview) {
      $('#review-fileupload-button').click();
    }
    this.setupReviewListener();
    // force rerender to cause images to lazyload correctly
    this.setState({ loaded: true });
  }

  setupReviewListener() {
    if (this.props.exploreFlag) {
      window.parent.document.addEventListener('updateReview', this.updateReview);
      window.parent.document.addEventListener('addReview', this.onReviewAdd);
      window.parent.document.addEventListener('addPhotos', this.onPhotosAdd);
      window.parent.document.addEventListener('addTrack', this.onTrackAdd);
    }
  }

  handleLoadMore = (data, dataType, newContentUploaded = false) => {
    // newContentUploaded indicates whether new content was uploaded or if we are simply loading more existing content from the server
    // newly uploaded content should be appended to the front of these arrays so it is displayed first
    let oldData;
    let newData;
    let newDataUnique;
    const { itemTotals } = this.state;
    this.setState({ loadingMore: true });
    if (dataType == 'reviews') {
      oldData = this.state.reviews.trail_reviews;
      if (newContentUploaded) {
        newData = data.trail_reviews.concat(oldData);
      } else {
        newData = oldData.concat(data.trail_reviews);
      }
      // filter these based on id as an extra duplicates check
      const uniqueIds = [];
      newDataUnique = [];
      for (let i = 0; i < newData.length; i++) {
        if (uniqueIds.indexOf(newData[i].id) === -1) {
          newDataUnique.push(newData[i]);
          uniqueIds.push(newData[i].id);
        }
      }

      // Has new user-entered review caused an auto-generated (from track) review to have been be deleted?
      if (data.trail_reviews && data.trail_reviews.length > 0 && data.trail_reviews[0] && data.trail_reviews[0].replacedGeneratedTrailReview) {
        newDataUnique = $.grep(newDataUnique, item => {
          return item.id != data.trail_reviews[0].replacedGeneratedTrailReview[0].id;
        });
      } else if (newContentUploaded) {
        // Normally will increment the review count, but not if we know this new real review replaced an auto-generated one
        itemTotals.reviews += 1;
      }

      this.setState({
        reviews: {
          meta: data.meta,
          trail_reviews: newDataUnique
        },
        itemTotals
      });
    } else if (dataType == 'tracks') {
      oldData = this.state.tracks.maps;
      if (newContentUploaded) {
        newData = data.maps.concat(oldData);
        itemTotals.maps += 1;
      } else {
        newData = oldData.concat(data.maps);
      }

      this.setState({
        tracks: {
          meta: data.meta,
          maps: newData
        },
        itemTotals
      });

      // Has the upload of this new recording caused a new auto-generated (from track) review to be created?
      if (data.maps && data.maps.length > 0 && data.maps[0] && data.maps[0].hasGeneratedTrailReview) {
        this.handleLoadMore({ trail_reviews: data.maps[0].hasGeneratedTrailReview }, 'reviews', true);
      }
    } else if (dataType == 'photos') {
      oldData = this.state.photos;
      newData = data.photos.map(p => {
        return {
          id: p.id,
          photoHash: p.photoHash
        };
      });

      let newPhotoArray;
      if (newContentUploaded) {
        newPhotoArray = newData.concat(oldData);
        itemTotals.photos += 1;
      } else {
        newPhotoArray = oldData.concat(newData);
      }

      this.setState({
        photos: newPhotoArray,
        itemTotals
      });
    } else if (dataType == 'completed') {
      oldData = this.state.completed.users;
      newData = oldData.concat(data.users);

      // filter these based on id as an extra duplicates check
      const uniqueIds = [];
      newDataUnique = [];
      for (let i = 0; i < newData.length; i++) {
        if (uniqueIds.indexOf(newData[i].id) === -1) {
          newDataUnique.push(newData[i]);
          uniqueIds.push(newData[i].id);
        }
      }

      this.setState({
        completed: {
          users: newDataUnique,
          connectionId: this.state.completed.connectionId
        },
        itemTotals
      });
    }
  };

  handleItemDelete = (data, dataType, trail) => {
    const { itemTotals } = this.state;
    if (dataType == 'reviews') {
      const items = $.grep(this.state.reviews.trail_reviews, item => {
        return item.id != data.id;
      });

      const oldObject = this.state.reviews;
      oldObject.trail_reviews = items;
      itemTotals.reviews -= 1;
      this.setState({
        reviews: oldObject,
        itemTotals
      });

      this.messagingChannel.publish({
        topic: 'reviews.changed',
        data: {
          avgRating: trail ? trail.avgRating : null
        }
      });
    } else if (dataType == 'tracks') {
      const items = $.grep(this.state.tracks.maps, item => {
        return item.id != data.id;
      });

      const oldObject = this.state.tracks;
      oldObject.maps = items;
      itemTotals.maps -= 1;
      this.setState({
        tracks: oldObject,
        itemTotals
      });
    }
  };

  onReviewAdd = data => {
    const trail_reviews = [data.detail, ...this.state.reviews.trail_reviews];
    this.setState({ reviews: { trail_reviews } });
  };

  updateReview = data => {
    const newReview = data.detail;
    const oldReview = this.state.reviews.trail_reviews.find(review => {
      return review.id === newReview.id;
    });

    if (oldReview) {
      this.handleReviewUpdated(oldReview, newReview);
    }
  };

  handleReviewUpdated = (oldReview, newReview) => {
    const currentReviews = this.state.reviews;
    const { trail_reviews } = currentReviews;
    for (let i = 0; i < trail_reviews.length; i++) {
      if (oldReview.id === trail_reviews[i].id) {
        trail_reviews[i] = newReview;
      }
    }
    this.setState({ reviews: currentReviews });
  };

  onPhotosAdd = data => {
    const photos = data.detail;
    const { itemTotals } = this.state;
    this.setState({ photos: [...this.state.photos, ...photos], itemTotals: { ...itemTotals, photos: itemTotals.photos + photos.length } });
  };

  onTrackAdd = data => {
    const track = data.detail;
    const {
      itemTotals,
      tracks,
      tracks: { maps }
    } = this.state;
    this.setState({ tracks: { ...tracks, maps: [...maps, track] }, itemTotals: { ...itemTotals, tracks: itemTotals.tracks + 1 } });
  };

  shouldReload = (data, dataType) => {
    // Force page reload all users after photo upload
    return dataType == 'photos';
  };

  setUgcLoading = () => {
    // Delay the loading message by 2 seconds so that it isn't flashing for quickly loading user generated content
    this.setState({ recordingsLoaded: false, reviewsLoaded: false, photosLoaded: false });
    setTimeout(() => {
      if (this.state.reviewsLoaded === true || this.state.photosLoaded === true || this.state.recordingsLoaded === true) {
        this.setState({ loadingSortedUgc: false });
      } else {
        this.setState({ loadingSortedUgc: true });
      }
    }, 2000);
  };

  sortTrailData = data => {
    // Sorts Reviews, Photos, and Recordings on respective views
    if (this.state.activeTab === 'Reviews') {
      this.sortReviews(data);
    } else if (this.state.activeTab === 'Recordings') {
      this.sortRecordings(data);
    } else if (this.state.activeTab === 'Photos') {
      this.sortPhotos(data);
    }
  };

  getBaseUrl() {
    if (this.props.baseUrl) {
      return this.props.baseUrl;
    }

    switch (this.props.section) {
      case 'PARK_PAGE':
        return `/api/alltrails/v2/locations/parks/${this.props.locationServerData.loc_id}`;
      case 'LOCATION_PAGE':
        return `/api/alltrails/v2/locations/${this.props.locationServerData.type}/${this.props.locationServerData.loc_id}`;
      case 'trail-show':
        return `/api/alltrails/v2/trails/${this.props.trailId}`;
      case 'user-reviews':
        return `/api/alltrails/users/${this.props.userId}`;
      case 'LIST_PAGE':
        return `/api/alltrails/lists/${this.props.listId}`;
      default:
        return '';
    }
  }

  sortReviews(data) {
    if (this.loadRequest && this.loadRequest.readyState != 4) this.loadRequest.abort();
    const baseUrl = this.getBaseUrl();
    const url = `${baseUrl}/reviews/`;
    const apiSuccessCallback = data => {
      this.setState({ reviews: { trail_reviews: data.trail_reviews }, reviewsLoaded: true, loadingSortedUgc: false });
    };
    const apiErrorCallback = data => {};
    const apiCompleteCallback = data => {};
    this.setState({ reviewSortOption: data.sort_option });
    if (typeof this.props.locationServerData !== 'undefined') {
      data.country_id = this.props.locationServerData.country_id;
      if (this.props.locationServerData.attribute) data.attribute = this.props.locationServerData.attribute;
      if (this.props.locationServerData.park_type) data.park_type = this.props.locationServerData.park_type;
    }
    data.per_page = this.props.reviewsPerPage;
    data.page = 1;

    let headers = {};
    if (this.props.locale) headers = { 'X-Language-Locale': this.props.locale };
    this.loadRequest = ServerCommunicationUtil.getApiEndpoint(url, data, apiSuccessCallback, apiErrorCallback, apiCompleteCallback, headers);
  }

  sortRecordings(data) {
    if (this.loadRequest && this.loadRequest.readyState != 4) this.loadRequest.abort();
    const baseUrl = this.getBaseUrl();
    const mapUrl = this.props.section === 'trail-show' ? '/maps/' : '/tracks/';
    const url = baseUrl + mapUrl;
    const apiSuccessCallback = data => {
      this.setState({ tracks: { maps: data.maps }, recordingsLoaded: true, loadingSortedUgc: false });
    };
    const apiErrorCallback = data => {};
    const apiCompleteCallback = data => {};
    this.setState({ recordingSortOption: data.sort_option });
    data.presentation_type = 'track';
    if (typeof this.props.locationServerData !== 'undefined') {
      data.country_id = this.props.locationServerData.country_id;
      if (this.props.locationServerData.attribute) data.attribute = this.props.locationServerData.attribute;
      if (this.props.locationServerData.park_type) data.park_type = this.props.locationServerData.park_type;
    }
    data.per_page = this.props.tracksPerPage;
    data.page = 1;
    this.loadRequest = ServerCommunicationUtil.getApiEndpoint(url, data, apiSuccessCallback, apiErrorCallback, apiCompleteCallback);
  }

  sortPhotos(data) {
    if (this.loadRequest && this.loadRequest.readyState != 4) this.loadRequest.abort();
    const baseUrl = this.getBaseUrl();
    const url = `${baseUrl}/photos/`;
    const apiSuccessCallback = data => {
      data = data.photos.map(p => {
        return {
          id: p.id,
          photoHash: p.photoHash
        };
      });
      this.setState({ photos: data, photosLoaded: true, loadingSortedUgc: false });
    };
    const apiErrorCallback = data => {};
    const apiCompleteCallback = data => {};
    this.setState({ photoSortOption: data.sort_option });
    if (typeof this.props.locationServerData !== 'undefined') {
      data.country_id = this.props.locationServerData.country_id;
      if (this.props.locationServerData.attribute) data.attribute = this.props.locationServerData.attribute;
      if (this.props.locationServerData.park_type) data.park_type = this.props.locationServerData.park_type;
    }
    data.per_page = this.props.photosPerPage;
    data.page = 1;
    this.loadRequest = ServerCommunicationUtil.getApiEndpoint(url, data, apiSuccessCallback, apiErrorCallback, apiCompleteCallback);
  }

  enabledSortLinks() {
    let sortLinks = [];
    if (this.state.activeTab === 'Photos') {
      sortLinks = ['atSort', 'desc', 'asc'];
    } else if (this.state.activeTab === 'Recordings') {
      sortLinks = ['desc', 'asc', 'highestRated', 'lowestRated'];
    } else if (this.state.activeTab === 'Reviews') {
      sortLinks = ['atSort', 'desc', 'asc', 'highestRated', 'lowestRated'];
    }
    return sortLinks;
  }

  displayFeeds() {
    const feeds = {};
    let reviews = [];
    let reviewsCount = 0;
    let tracksCount = 0;
    let photosCount = 0;
    const ugcSortDropDown = this.renderUgcSortDropdown();
    if (this.state.reviews != null) {
      reviews = this.state.reviews.trail_reviews;
      reviewsCount = this.state.itemTotals.reviews;
      feeds.Reviews = (
        <TrailActivityFeed
          key="reviews"
          feedType="reviews"
          items={reviews}
          perPage={this.props.reviewsPerPage}
          userId={this.props.userId}
          adminUser={this.props.adminUser}
          handleItemDelete={this.handleItemDelete}
          updateReview={this.updateReview}
          loadMore={this.handleLoadMore}
          sortOption={this.state.reviewSortOption}
          maxItems={reviewsCount}
          trailId={this.props.trailId}
          trailName={this.props.trailName}
          locationServerData={this.props.locationServerData}
          includeTrailName={this.props.includeTrailName}
          includeUserName={this.props.includeUserName}
          ratingsBreakdown={this.props.ratingsBreakdown}
          section={this.props.section}
          locale={this.props.locale}
          currentUserId={this.props.currentUserId}
          onReviewAdd={this.onReviewAdd}
          visible={this.state.activeTab === 'Reviews'}
          ugcSortDropDown={ugcSortDropDown}
          showContributeButton={this.props.showContributeButton}
          mobileBrowser={this.props.mobileBrowser}
        />
      );
    }
    let photos = [];
    if (this.state.photos != null) {
      photos = this.state.photos;
      photosCount = this.state.itemTotals.photos;
      feeds.Photos = (
        <TrailActivityFeed
          key="photos"
          feedType="photos"
          items={photos}
          perPage={this.props.photosPerPage}
          photoSize={this.props.photoSize}
          userId={this.props.userId}
          adminUser={this.props.adminUser}
          maxItems={photosCount}
          loadMore={this.handleLoadMore}
          shouldReload={this.shouldReload}
          sortOption={this.state.photoSortOption}
          locationServerData={this.props.locationServerData}
          locale={this.props.locale}
          loaded={this.state.loaded}
          trailId={this.props.trailId}
          onPhotosAdd={this.onPhotosAdd}
          visible={this.state.activeTab === 'Photos'}
          exploreFlag={this.props.exploreFlag}
          ugcSortDropDown={ugcSortDropDown}
          showContributeButton={this.props.showContributeButton}
          showInvitation={this.props.showInvitation}
        />
      );
    }
    let tracks = [];
    if (this.state.tracks != null) {
      tracks = this.state.tracks.maps;
      tracksCount = this.state.itemTotals.maps;
      feeds.Recordings = (
        <TrailActivityFeed
          key="recordings"
          feedType="tracks"
          items={tracks}
          perPage={this.props.tracksPerPage}
          userId={this.props.userId}
          adminUser={this.props.adminUser}
          displayMetric={this.props.displayMetric}
          adminOrPendingOwner={this.props.adminOrPendingOwner}
          handleItemDelete={this.handleItemDelete}
          loadMore={this.handleLoadMore}
          sortOption={this.state.recordingSortOption}
          locationServerData={this.props.locationServerData}
          maxItems={tracksCount}
          includeUserName={this.props.includeUserName}
          includeTrailName={this.props.includeTrailName}
          locale={this.props.locale}
          trailId={this.props.trailId}
          onTrackAdd={this.onTrackAdd}
          visible={this.state.activeTab === 'Recordings'}
          ugcSortDropDown={ugcSortDropDown}
        />
      );
    }
    if (this.state.completed != null) {
      feeds.Completed = (
        <TrailActivityFeed
          key="completed"
          feedType="completed"
          completedConnectionId={this.state.completed.connectionId}
          currentUserId={this.props.currentUserId}
          handleCompletedConnectionChanged={this.handleCompletedConnectionChanged}
          items={this.state.completed.users}
          perPage={this.props.completedPerPage}
          userId={this.props.userId}
          adminUser={this.props.adminUser}
          adminOrPendingOwner={this.props.adminOrPendingOwner}
          handleItemDelete={this.handleItemDelete}
          loadMore={this.handleLoadMore}
          locationServerData={this.props.locationServerData}
          maxItems={this.state.itemTotals.completed}
          messagingChannel={this.messagingChannel}
          includeUserName={this.props.includeUserName}
          locale={this.props.locale}
          trailId={this.props.trailId}
          visible={this.state.activeTab === 'Completed'}
        />
      );
    }

    if (this.state.loadingSortedUgc === false) {
      return (
        <>
          {feeds.Reviews}
          {feeds.Photos}
          {feeds.Recordings}
          {feeds.Completed}
        </>
      );
    }
    const feedType = StringConstantsMixin.stringsLookup(StringConstantsMixin.strings.TAB_NAMES, this.state.activeTab).toLowerCase();

    return (
      <div className={styles.loadingSortingMessage}>
        <h4 className={styles.emptyHeader}>{`${StringConstantsMixin.strings.SEARCH.LOADING_NO_ELLIPSIS} ${feedType}`}...</h4>
        <div className={`${styles.icon} ${styles[this.state.activeTab.toLowerCase()]}`}>
          <p className={styles.iconText}>{`${StringConstantsMixin.strings.SEARCH.SORTING_LOAD_MSG} ${feedType}`}</p>
        </div>
      </div>
    );
  }

  handleCompletedConnectionChanged = completedConnectionId => {
    const { completed, itemTotals } = this.state;
    if (completedConnectionId && !completed.connectionId) {
      completed.users.push(this.props.currentUser);
      itemTotals.completed = itemTotals.completed == null ? 1 : itemTotals.completed + 1;
    } else if (!completedConnectionId && completed.connectionId) {
      completed.users = completed.users.filter(user => {
        return user.id != this.props.currentUser.id;
      });
      itemTotals.completed = itemTotals.completed > 0 ? itemTotals.completed - 1 : 0;
    }
    completed.connectionId = completedConnectionId;
    this.setState({ completed, itemTotals });
  };

  handleTabChange = (e, activeTabIndex) => {
    e.preventDefault();
    if (activeTabIndex === this.state.activeTabIndex) {
      return;
    }
    const visibleTabs = this.determineVisibleTabs();
    this.setState({ activeTabIndex, activeTab: visibleTabs[activeTabIndex].key });
  };

  determineVisibleTabs() {
    const visibleTabs = [];
    const reviewsCount = this.state.itemTotals.reviews;
    if (reviewsCount || reviewsCount === 0) {
      const reviewCountFormatted = MapStatsUtil.formatData(reviewsCount, 0, null, this.props.locale);
      visibleTabs.push({ label: `${StringConstantsMixin.strings.TAB_NAMES.REVIEWS} (${reviewCountFormatted})`, key: 'Reviews' });
    }
    const photosCount = this.state.itemTotals.photos;
    if (photosCount || photosCount === 0) {
      const photosCountFormatted = MapStatsUtil.formatData(photosCount, 0, null, this.props.locale);
      visibleTabs.push({ label: `${StringConstantsMixin.strings.TAB_NAMES.PHOTOS} (${photosCountFormatted})`, key: 'Photos' });
    }
    const tracksCount = this.state.itemTotals.maps;
    if (tracksCount || tracksCount === 0) {
      const tracksCountFormatted = MapStatsUtil.formatData(tracksCount, 0, null, this.props.locale);
      visibleTabs.push({ label: `${StringConstantsMixin.strings.TAB_NAMES.RECORDINGS} (${tracksCountFormatted})`, key: 'Recordings' });
    }
    const completedCount = this.state.itemTotals.completed;
    if (completedCount || completedCount === 0) {
      const completedCountFormatted = MapStatsUtil.formatData(completedCount, 0, null, this.props.locale);
      visibleTabs.push({ label: `${StringConstantsMixin.strings.TAB_NAMES.COMPLETED} (${completedCountFormatted})`, key: 'Completed' });
    }
    return visibleTabs;
  }

  renderSelectionBar() {
    if (this.props.hideSelectionBar) {
      return null;
    }
    const visibleTabs = this.determineVisibleTabs();
    return (
      <SlidingTabs
        onChange={this.handleTabChange}
        activeIndex={this.state.activeTabIndex}
        slidingTabsClasses={{ root: styles.slidingTabs }}
        tabs={visibleTabs}
      />
    );
  }

  renderUgcSortDropdown() {
    let activeSortOption = null;
    if (this.state.activeTab == 'Reviews') {
      activeSortOption = this.state.reviewSortOption;
    } else if (this.state.activeTab == 'Photos') {
      activeSortOption = this.state.photoSortOption;
    } else if (this.state.activeTab == 'Recordings') {
      activeSortOption = this.state.recordingSortOption;
    }
    return (
      <UgcSortDropdown
        sortTrailData={this.sortTrailData}
        setUgcLoading={this.setUgcLoading}
        enabledSortLinks={this.enabledSortLinks()}
        selectedSort={activeSortOption}
      />
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.renderSelectionBar()}
        <div className={styles.tabContainer}>{this.displayFeeds()}</div>
      </div>
    );
  }
}

TrailFeeds.propTypes = {
  adminOrPendingOwner: bool,
  adminUser: bool,
  completed: shape({
    connectionId: number,
    users: arrayOf(object),
    completedPerPage: number
  }),
  currentUser: object,
  currentUserId: number,
  exploreFlag: bool,
  includeTrailName: bool,
  includeUserName: bool,
  itemTotals: shape({
    reviews: number,
    photos: number,
    maps: number,
    completed: number
  }),
  locale: string,
  modalSigninPath: string,
  photos: arrayOf(shape({ id: number, photoHash: string })),
  photosPerPage: number,
  popTrailReview: bool,
  profilePhotoId: number,
  reviews: shape({
    meta: shape({
      status: string,
      items: number,
      timestamp: string
    }),
    trail_reviews: arrayOf(
      shape({
        activity: shape({
          description: string,
          name: string,
          uid: string,
          bitfieldPosition: number,
          type: string
        }),
        badges: shape({ first: bool }),
        comment: string,
        dataUid: string,
        date: string,
        id: number,
        rating: number,
        trailId: number,
        trailName: string,
        trailSlug: string
      })
    ),
    reviewsPerPage: number,
    section: string,
    showContributeButton: bool,
    showInvitation: bool,
    tracksPerPage: number,
    trailId: number,
    trailName: string,
    trailUrl: string
  })
};

TrailFeeds.defaultProps = {
  includeUserName: true,
  includeTrailName: false,
  popTrailReview: false,
  sortOption: 'atSort',
  reviewsPerPage: 30,
  photosPerPage: 56,
  tracksPerPage: 30,
  completedPerPage: 10,
  showContributeButton: true,
  showInvitation: true
};

export default TrailFeeds;
